import get from 'lodash/get'
import { loadLink } from '../utils'

export const useCustomIcons = ({ config, loadIcons = false }) => {
  const hasCustomIcons = get(config, 'icons.custom')
  const iconOverrides = get(config, 'icons.override')
  const overrideCss = get(config, 'icons.overrideCss')
  const overridePrefix = get(config, 'icons.prefix', '')
  const loadIconPromises = []

  if (hasCustomIcons && loadIcons) {
    // load custom icon set
    loadIconPromises.push(new Promise(resolve => loadLink({ href: 'resources/css/icons.css', onloadFn: resolve })))
  } else if (loadIcons) {
    loadIconPromises.push(import('../icons/app/icons.css'))
  }

  if (iconOverrides && overrideCss && loadIcons) {
    loadIconPromises.push(loadLink(overrideCss))
  }

  const iconMapFn = (iconName) => {
    if (iconName.startsWith('app:')) {
      const name = iconName.substring(4)
      let cls = null

      if (iconOverrides?.[name]) {
        cls = overridePrefix + iconOverrides[name]
      } else {
        cls = 'w-icon-' + name
      }

      return { cls }
    } else if (iconOverrides?.[iconName]) {
      return { cls: iconOverrides?.[iconName] }
    }
  }

  return { iconMapFn, loadPromise: Promise.all(loadIconPromises) }
}
